import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting, useAppState } from "@nosto/preact"
import { handleSwatch, calculatePercentage } from "../helpers"
import { useState, useMemo, useEffect } from "preact/hooks"
import Swatches from './Swatches'

export default function Product({ product, oneBrand, swatchData, storefrontData }) {
    const { response: { products } } = useAppState()
    const { format } = useCurrencyFormatting()

    const masterTag = useMemo(() => product?.tags1?.find(tag => tag.includes('andie::master')), []);
    const productName = useMemo(() => product?.tags1?.find(tag => tag.includes('short-title'))?.split(":").pop(), []);
    const productColor = useMemo(() => product?.tags1?.find(tag => tag.includes('color:'))?.split(":").pop(), []);
    const badge = useMemo(() => product?.tags1?.find(tag => tag.includes('badge:'))?.split(":").pop(), []);
    const features = useMemo(() => product?.customFields?.find(field => field.key == 'custom-nosto_features')?.value, []);
    const tagPromo = useMemo(() => product?.tags1?.find(tag => tag.includes('plp-promo:'))?.split(":").pop(), []);

    const store = window?.__VPV.store
    const currentBrand = store?.currentBrand

    if (currentBrand == 'richer-poorer') {
        isRicherPoorer = true
    } else {
        isRicherPoorer = false
    }

    const globalDiscountMessaging = window?.__VPV?.globalDiscountMessaging
    const andiePromoTextColor = globalDiscountMessaging?.andiePromoTextColor
    const rpPromoTextColor = globalDiscountMessaging?.rpPromoTextColor
    const andiePromoBackgroundColor = globalDiscountMessaging?.andiePromoBackgroundColor
    const rpPromoBackgroundColor = globalDiscountMessaging?.rpPromoBackgroundColor
    const promoIsActive = globalDiscountMessaging?.isActive
    const andiePromoEnabled = globalDiscountMessaging?.andieEnabled
    const rpPromoEnabled = globalDiscountMessaging?.rpEnabled
    const andieCollectionEnabled = globalDiscountMessaging?.andieCollectionEnabled
    const rpCollectionEnabled = globalDiscountMessaging?.rpCollectionEnabled
    const andieCollection = globalDiscountMessaging?.andieCollection
    const rpCollection = globalDiscountMessaging?.rpCollection
    const currentCollection = window?.__VPV?.shop?.collection
    const productCardDiscountMessageAndie = globalDiscountMessaging?.productCardDiscountMessageAndie
    const productCardDiscountMessageRP = globalDiscountMessaging?.productCardDiscountMessageRP
    const nagPromo = false

    // Waterfall logic for showing the product promotion using variables from global store set in the theme's settings. Applies to both brands

    showTagPromoMessage = false
    showRPPromoMessage = false
    showAndiePromoMessage = false
 
    if (tagPromo) {
        showTagPromoMessage = true
    } else if (promoIsActive) {
        if (andieCollectionEnabled && currentCollection.handle == andieCollection && productCardDiscountMessageAndie) {
            showAndiePromoMessage = true
        } else if (rpCollectionEnabled && currentCollection.handle == rpCollection && productCardDiscountMessageRP) {
            showRPPromoMessage = true
        } else if (andiePromoEnabled && productCardDiscountMessageAndie && product.brand == 'Andie' && !isRicherPoorer) {
            showAndiePromoMessage = true
        } else if (rpPromoEnabled && productCardDiscountMessageRP && product.brand == 'Richer Poorer' && isRicherPoorer) {
            showRPPromoMessage = true
        }
    }

    var relatedProducts = useMemo(() => swatchData.filter(product => product.tags1.includes(masterTag)), [swatchData]);
    if((product.name).includes("Long Torso")){
        relatedProducts = relatedProducts.filter(prod => prod.name.includes("Long Torso"));
    } else {
        relatedProducts = relatedProducts.filter(prod => !prod.name.includes("Long Torso"));
    }

    if(!product.name.includes("Cheeky")){
        relatedProducts = relatedProducts.filter(prod => !prod.name.includes("Cheeky"));
    }
    if(!product.name.includes("Full Coverage")){
        relatedProducts = relatedProducts.filter(prod => !prod.name.includes("Full Coverage"));
    }
    if(!product.name.includes("Medium Coverage")){
        relatedProducts = relatedProducts.filter(prod => !prod.name.includes("Medium Coverage"));
    }
  
    return (
        <SerpElement
            as="div"
            hit={product}
            class={`ns-product product-card ns-relative ${isRicherPoorer ? 'ns-product-rp' : ''}`}
            data-handle={product.url.toString().split("/products/").pop()}
        >
           
                {window.innerWidth < 1024 &&
                 <a href={product.url} class="mb-2 block relative group ns-mobile-image-wrapper">
                    <div class="ns-mobile-carousel">
                        <img 
                            src={`${product.imageUrl.toString().replace(".jpg", "_40x.jpg")}`}
                            data-srcset={`${product.imageUrl.toString().replace(".jpg", "_300x.jpg")} 200w, ${product.imageUrl.toString().replace(".jpg", "_400x.jpg")} 300w, ${product.imageUrl.toString().replace(".jpg", "_600x.jpg")} 500w, ${product.imageUrl.toString().replace(".jpg", "_700x.jpg")} 600w, ${product.imageUrl.toString().replace(".jpg", "_1000x.jpg")} 900w,  ${product.imageUrl.toString().replace(".jpg", "_1300x.jpg")} 1200w,  ${product.imageUrl.toString().replace(".jpg", "_1600x.jpg")} 1500w,  ${product.imageUrl.toString().replace(".jpg", "_1900x.jpg")} 1800w, ${product.imageUrl.toString().replace(".jpg", "_1000x.jpg")} 1900w`}
                            data-sizes="auto" 
                            loading="lazy"
                            width="0" 
                            height="0" 
                            alt={product.name} 
                            class="w-full lazyautosizes ls-is-cached lazyloaded" 
                            sizes="195px" 
                            srcset={`${product.imageUrl.toString().replace(".jpg", "_300x.jpg")} 200w, ${product.imageUrl.toString().replace(".jpg", "_400x.jpg")} 300w, ${product.imageUrl.toString().replace(".jpg", "_600x.jpg")} 500w, ${product.imageUrl.toString().replace(".jpg", "_700x.jpg")} 600w, ${product.imageUrl.toString().replace(".jpg", "_1000x.jpg")} 900w,  ${product.imageUrl.toString().replace(".jpg", "_1300x.jpg")} 1200w,  ${product.imageUrl.toString().replace(".jpg", "_1600x.jpg")} 1500w,  ${product.imageUrl.toString().replace(".jpg", "_1900x.jpg")} 1800w, ${product.imageUrl.toString().replace(".jpg", "_1000x.jpg")} 1900w`}
                        />
                        {product.alternateImageUrls &&
                            <img 
                                src={product.alternateImageUrls[0]}
                                data-srcset={`${product.alternateImageUrls[0].toString().replace(".jpg", "_300x.jpg")} 200w, ${product.alternateImageUrls[0].toString().replace(".jpg", "_400x.jpg")} 300w, ${product.alternateImageUrls[0].toString().replace(".jpg", "_600x.jpg")} 500w, ${product.alternateImageUrls[0].toString().replace(".jpg", "_700x.jpg")} 600w, ${product.alternateImageUrls[0].toString().replace(".jpg", "_1000x.jpg")} 900w,  ${product.alternateImageUrls[0].toString().replace(".jpg", "_1300x.jpg")} 1200w,  ${product.alternateImageUrls[0].toString().replace(".jpg", "_1600x.jpg")} 1500w,  ${product.alternateImageUrls[0].toString().replace(".jpg", "_1900x.jpg")} 1800w, ${product.alternateImageUrls[0].toString().replace(".jpg", "_1000x.jpg")} 1900w`}
                                data-sizes="auto" 
                                loading="lazy"
                                width="0" 
                                height="0" 
                                alt={product.name} 
                                class="w-full lazyautosizes ls-is-cached lazyloaded ns-sec-image" 
                                sizes="195px" 
                                srcset={`${product.alternateImageUrls[0].toString().replace(".jpg", "_300x.jpg")} 200w, ${product.alternateImageUrls[0].toString().replace(".jpg", "_400x.jpg")} 300w, ${product.alternateImageUrls[0].toString().replace(".jpg", "_600x.jpg")} 500w, ${product.alternateImageUrls[0].toString().replace(".jpg", "_700x.jpg")} 600w, ${product.alternateImageUrls[0].toString().replace(".jpg", "_1000x.jpg")} 900w,  ${product.alternateImageUrls[0].toString().replace(".jpg", "_1300x.jpg")} 1200w,  ${product.alternateImageUrls[0].toString().replace(".jpg", "_1600x.jpg")} 1500w,  ${product.alternateImageUrls[0].toString().replace(".jpg", "_1900x.jpg")} 1800w, ${product.alternateImageUrls[0].toString().replace(".jpg", "_1000x.jpg")} 1900w`}
                            />
                        }
                    </div>
                 </a>
                }
                {window.innerWidth >= 1024 &&
                    <a href={product.url} class="mb-2 block relative padding-aspect padding-aspect--5/7 group ns-image-wrapper">
                        <img 
                        src={product.imageUrl}
                        data-srcset={`${product.imageUrl.toString().replace(".jpg", "_300x.jpg")} 200w, ${product.imageUrl.toString().replace(".jpg", "_400x.jpg")} 300w, ${product.imageUrl.toString().replace(".jpg", "_600x.jpg")} 500w, ${product.imageUrl.toString().replace(".jpg", "_1000x.jpg")} 900w,  ${product.imageUrl.toString().replace(".jpg", "_1300x.jpg")} 1200w,  ${product.imageUrl.toString().replace(".jpg", "_1600x.jpg")} 1500w,  ${product.imageUrl.toString().replace(".jpg", "_1900x.jpg")} 1800w, ${product.imageUrl.toString().replace(".jpg", "_1000x.jpg")} 1900w`}
                        data-sizes="auto" 
                        loading="lazy"
                        width="100%" 
                        height="100%" 
                        alt={product.name} 
                        class="w-full lazyautosizes ls-is-cached lazyloaded" 
                        sizes="425px" 
                        srcset={`${product.imageUrl.toString().replace(".jpg", "_300x.jpg")} 200w, ${product.imageUrl.toString().replace(".jpg", "_400x.jpg")} 300w, ${product.imageUrl.toString().replace(".jpg", "_600x.jpg")} 500w, ${product.imageUrl.toString().replace(".jpg", "_1000x.jpg")} 900w,  ${product.imageUrl.toString().replace(".jpg", "_1300x.jpg")} 1200w,  ${product.imageUrl.toString().replace(".jpg", "_1600x.jpg")} 1500w,  ${product.imageUrl.toString().replace(".jpg", "_1900x.jpg")} 1800w, ${product.imageUrl.toString().replace(".jpg", "_1000x.jpg")} 1900w`}
                        />
                        {product.alternateImageUrls &&
                            <img 
                                src={product.alternateImageUrls[0]}
                                data-srcset={`${product.alternateImageUrls[0].toString().replace(".jpg", "_300x.jpg")} 200w, ${product.alternateImageUrls[0].toString().replace(".jpg", "_400x.jpg")} 300w, ${product.alternateImageUrls[0].toString().replace(".jpg", "_600x.jpg")} 500w, ${product.alternateImageUrls[0].toString().replace(".jpg", "_1000x.jpg")} 900w,  ${product.alternateImageUrls[0].toString().replace(".jpg", "_1300x.jpg")} 1200w,  ${product.alternateImageUrls[0].toString().replace(".jpg", "_1600x.jpg")} 1500w,  ${product.alternateImageUrls[0].toString().replace(".jpg", "_1900x.jpg")} 1800w, ${product.alternateImageUrls[0].toString().replace(".jpg", "_1000x.jpg")} 1900w`}
                                data-sizes="auto" 
                                loading="lazy"
                                width="100%" 
                                height="100%" 
                                alt={product.name} 
                                class="w-full lazyautosizes ls-is-cached lazyloaded ns-sec-image" 
                                sizes="425px" 
                                srcset={`${product.alternateImageUrls[0].toString().replace(".jpg", "_300x.jpg")} 200w, ${product.alternateImageUrls[0].toString().replace(".jpg", "_400x.jpg")} 300w, ${product.alternateImageUrls[0].toString().replace(".jpg", "_600x.jpg")} 500w, ${product.alternateImageUrls[0].toString().replace(".jpg", "_1000x.jpg")} 900w,  ${product.alternateImageUrls[0].toString().replace(".jpg", "_1300x.jpg")} 1200w,  ${product.alternateImageUrls[0].toString().replace(".jpg", "_1600x.jpg")} 1500w,  ${product.alternateImageUrls[0].toString().replace(".jpg", "_1900x.jpg")} 1800w, ${product.alternateImageUrls[0].toString().replace(".jpg", "_1000x.jpg")} 1900w`}
                            />
                        }
                    </a>
                }
                {badge && !product.onDiscount &&
                    <button
                        type="button"
                        class={`ns-badge ns-absolute ns-${badge} ${isRicherPoorer ? 'ns-badge-rp' : ''}`}
                    > 
                        {badge}
                    </button>
                }
                {product.onDiscount &&
                    <button
                        type="button"
                        class={`ns-badge ns-absolute ns-sale ${isRicherPoorer ? 'ns-sale-rp' : ''}`}
                    > 
                        {calculatePercentage(product)}% Off
                    </button>
                }
            {relatedProducts.length > 1 && <Swatches product={product} relatedProducts={relatedProducts} storefrontData={storefrontData}/>}
            <div class="mb-2 ns-product-details" data-nosto-element="product">
                {!oneBrand && product.brand && (
                    <p class="mr-2 circularbook--paragraph text-left ns-vendor-name">{product.brand}</p>
                )}
                <p class="mr-2 circularbook--paragraph text-left capitalize ns-product-name">{productName ? productName : product.name}</p>
                <div class="ns-price-wrapper">
                    {product.listPrice && product.listPrice > product.price && (
                        <span class="circularbook--paragraph ns-product-price ns-text-striked">
                            {format(product.listPrice)}
                        </span>
                    )}
                    <span class={`circularbook--paragraph ns-product-price ${product.onDiscount ? 'ns-discounted-price' : ''} ${isRicherPoorer ? 'ns-discounted-price-rp' : ''}`}>{format(product.price)}</span>
                </div>
                <div class="ns-product-features">
                    {features && 
                        <span>Available in: {JSON.parse(features).join(' | ')}</span>
                    }
                </div>
                {showTagPromoMessage && <div class="ns-promo" style={`${isRicherPoorer ? `color: ${rpPromoTextColor}; background-color: ${rpPromoBackgroundColor}` : `color: ${andiePromoTextColor}; background-color: ${andiePromoBackgroundColor}`}`}>{tagPromo}</div>}
                {showAndiePromoMessage && !showTagPromoMessage && <div class="ns-promo" style={`${isRicherPoorer ? `color: ${rpPromoTextColor}; background-color: ${rpPromoBackgroundColor};` : `color: ${andiePromoTextColor}; background-color: ${andiePromoBackgroundColor};`}`}>{productCardDiscountMessageAndie}</div>}
                {showRPPromoMessage && !showTagPromoMessage && <div class="ns-promo" style={`${isRicherPoorer ? `color: ${rpPromoTextColor}; background-color: ${rpPromoBackgroundColor};` : `color: ${andiePromoTextColor}; background-color: ${andiePromoBackgroundColor};`}`}>{productCardDiscountMessageRP}</div>}
            </div>
        </SerpElement>
    )
}
